// extracted by mini-css-extract-plugin
export var actions = "_x-0";
export var actionsContainer = "_x-7";
export var border = "_x-1";
export var childFullHeight = "_x-f";
export var collapse = "_x-2";
export var content = "_x-a";
export var contentChild = "_x-e";
export var fullscreen = "_x-c";
export var hasLeftRadius = "_x-k";
export var headerContainer = "_x-3";
export var headerRow = "_x-5";
export var hidePadding = "_x-b";
export var navCollapsedGap = "_x-l";
export var noScrollX = "_x-m";
export var noScrollY = "_x-n";
export var noTopPadding = "_x-i";
export var optOutTopPadding = "_x-d";
export var pageMain = "_x-j";
export var pageOuter = "_x-g";
export var pagePadding = "_x-8";
export var pageScroll = "_x-9";
export var profile = "_x-o";
export var profileContainer = "_x-p";
export var profileImage = "_x-q";
export var profileMain = "_x-r";
export var profileSubtitle = "_x-t";
export var profileTitle = "_x-s";
export var showLeftPadding = "_x-h";
export var tabsPortalSlot = "_x-6";
export var tabsWrapper = "_x-4";
export var title = "_x-u";